<template>
  <div id="root">
    <div class="page-header inner">
      <h1 data-test="title">Unauthorized</h1>
      <p>You are not authorized to view this page.</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Unauthorized'
};
</script>

<style scoped>

</style>
